import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import { deserialize } from "utils/storeUtils";
import OffersRepository from "repositories/OffersRepository";

const initialState = {
  offer: null,
  error: null,
};

const offersSlice = createSlice({
  name: "offers",
  initialState,
  reducers: {
    loadOfferSuccess(state, { payload }) {
      state.offer = deserialize(payload);
    },
    loadOfferFail(state, { payload }) {
      state.error = payload;
    },
  },
});

export const { actions } = offersSlice;
export default offersSlice.reducer;

export const useOffersActions = () => {
  const dispatch = useDispatch();

  const loadOffer = async (slug) => {
    try {
      const { data } = await OffersRepository.show(slug);
      dispatch(offersSlice.actions.loadOfferSuccess(data));
    } catch (error) {
      dispatch(offersSlice.actions.loadOfferFail(error.toString()));
      throw new Error(error);
    }
  };

  return {
    loadOffer,
  };
};
